import FeatureCard from "./SharedComponents/FeatureCard";
import { images } from "../../assets/Images/assetsImages";

const FeaturesSection = () => {

    const featuresData = [
        { title: "Open Kitchen Experience", image: images.Feature1 },
        { title: "European Artisanal Recipes", image: images.Feature2 },
        { title: "Fresh Ingredients", image: images.Feature3 },
      ];

  return (
    <section className="w-full h-full">
        <div className="flex flex-wrap justify-center bg-[#e6f3cd] gap-24 px-8 pb-12">
            {featuresData.map((feature, index) => (
                <FeatureCard key={index} title={feature.title} image={feature.image} />
            ))}
        </div>
        <div className="w-full h-full">
            <img src={images.FeatureSectionShape} alt="Shape" className="w-full h-full"></img>
        </div>
    </section>
  )
}

export default FeaturesSection
